import './App.css';
import { useState } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import CheckConnection from 'components/CheckConnection';
import ModalWelcomeAI from 'v2/components/ModalWelcomeAI';
import ChatFloantig from 'v2/components/ChatFloantig';
import Header from 'v2/components/Header';
import { CssVarsProvider } from '@mui/joy';
import CssBaseline from '@mui/material/CssBaseline';

import Progress from './components/Progress';
import Snackbar from './components/Snack/Snackbar';
import { useAppSelector } from 'v2/resources/hooks/useAppSelector';
import { useWindowSizes } from 'v2/resources/hooks/useWindowSizes';
import Box from 'v2/components/UI/Box';
import Text from 'v2/components/UI/Text';

const drawerWidth = 300;
const drawerTop = 110;

const drawerWidthXs = -11;
const drawerTopXs = 90;

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    background: '#F7F6F9',
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      paddingTop: drawerTop,
    },
    [theme.breakpoints.down('sm')]: {
      width: `calc(100% - ${drawerWidthXs}px)`,
      marginLeft: drawerWidthXs,
      paddingTop: drawerTopXs,
    },
  },
}));

function MainComponent() {
  const location = useLocation();

  const { resolutionNotSupported, isMobile, isTablet } = useWindowSizes();
  const blackListChatFloating = [
    '/greenfy-ai',
    '/instructions',
    '/settings-ai',
    '/add-files-ai',
    '/list-files-ai',
    '/edit-files-ai',
  ];

  const classes = useStyles();
  const isAuth = useAppSelector((state) => state.authenticated.authenticated);
  const loading = useAppSelector((state) => state.loading.loading);

  const [showModalWelcomeAI, setShowModalWelcomeAI] = useState(true);

  const handleShowModalWelcomeAI = () => {
    setShowModalWelcomeAI((prevState) => !prevState);
  };

  const renderContentOrMessageError = () => {
    if (resolutionNotSupported) {
      return (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={'100vh'}
        >
          <Text color="#5f1300" fontSize={30} fontWeight={700}>
            RESOLUÇÃO NÃO SUPORTADA!
          </Text>
        </Box>
      );
    }
    return (
      <div style={{ background: '#F7F6F9', overflow: 'auto' }}>
        {loading && <Progress />}
        <Snackbar />

        {isAuth && location.pathname === '/home' && (
          <ModalWelcomeAI
            onClose={handleShowModalWelcomeAI}
            isOpen={showModalWelcomeAI}
          />
        )}

        {isAuth && (
          <CssVarsProvider>
            {' '}
            <Header />
          </CssVarsProvider>
        )}

        <CssBaseline />

        {isAuth && !blackListChatFloating.includes(location.pathname) && (
          <ChatFloantig />
        )}

        <div
          id="content"
          className={isAuth && classes.footer}
          style={{
            width:
              isMobile || isTablet ? '100%' : `calc(100% - ${drawerWidth}px)`,
            marginLeft: isMobile || isTablet ? 0 : drawerWidth,
            paddingRight: isMobile || isTablet ? 0 : 20,
            paddingLeft: isMobile || isTablet ? 0 : 10,
            marginTop: 10,
          }}
        >
          <CheckConnection />
        </div>
      </div>
    );
  };

  return renderContentOrMessageError();
}

export default function App() {
  return (
    <BrowserRouter>
      <MainComponent />
    </BrowserRouter>
  );
}
